export const ANALYTICS_EXTERNAL_DATA = 'analytics-external-data';
